module.exports = __webpack_public_path__ + "static/media/12596078_957577634291878_863985030_n.13f98cb9.jpg";